import { Button, Dialog, Portal } from '@chakra-ui/react'
import { LuCircleCheck } from 'react-icons/lu'

import { DialogAccent } from '@/components/ui/DialogAccent'

interface InterestSubmittedDialogProps {
  open: boolean
  onClose: () => void
}

export function InterestSubmittedDialog({ open, onClose }: InterestSubmittedDialogProps) {
  return (
    <Dialog.Root accented open={open} onOpenChange={details => !details.open && onClose()}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <DialogAccent icon={LuCircleCheck} colorPalette="green" />

            <Dialog.Header>
              <Dialog.Title>Sie haben Ihr Interesse angemeldet</Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Dialog.Description>
                Sofern Union Investment Ihnen den Zuschlag erteilt, erhalten Sie die Kontaktdaten
                der zuständigen Ansprechpartner. Die weiteren Details zur Bestellung stimmen Sie
                anschließend direkt mit diesen ab.
              </Dialog.Description>
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button>Schließen</Button>
              </Dialog.ActionTrigger>
            </Dialog.Footer>

            <Dialog.CloseTrigger />
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
